/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiGroupReservationFromJSON, StreemApiGroupReservationToJSON, } from './';
export function StreemApiGetGroupReservationResponseFromJSON(json) {
    return StreemApiGetGroupReservationResponseFromJSONTyped(json, false);
}
export function StreemApiGetGroupReservationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'groupReservation': !exists(json, 'group_reservation') ? undefined : StreemApiGroupReservationFromJSON(json['group_reservation']),
    };
}
export function StreemApiGetGroupReservationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'group_reservation': StreemApiGroupReservationToJSON(value.groupReservation),
    };
}
//# sourceMappingURL=StreemApiGetGroupReservationResponse.js.map